import { useQuery } from 'react-query';
import { FileTypes } from 'taboola-ultimate-ui';
import { modifyExternalUrl } from 'modules/campaigns/services/utils';
import { aiGenerationApi } from 'services/api';

export const useFetchAIGeneratedMotion = ({ imageUrl, accountId, setVideos, isRegenerated }) => {
    return useQuery(
        ['fetchAIGeneratedMotion'],
        async () => {
            try {
                const { video, message } = await aiGenerationApi.getAIGeneratedMotionFromImage({
                    accountId,
                    imageUrl,
                    isRegenerated,
                });
                if (message) {
                    throw new Error(message);
                }
                const url = modifyExternalUrl(video.url);
                const thumbnailUrl = modifyExternalUrl(video.fallbackImageUrl);
                return {
                    result: {
                        url,
                        thumbnailUrl,
                        id: url,
                        fileType: FileTypes.VIDEO,
                    },
                };
            } catch (error) {
                throw error;
            }
        },
        {
            enabled: false,
            onSuccess: data => {
                setVideos(prev => [...prev, data.result]);
            },
            retry: 1,
            refetchOnWindowFocus: false,
        }
    );
};
